<div class="d-flex flex-column align-items-center justify-content-start influencer-summarize-content full-height" *ngIf="influencer.value && influencer.name">
  <div class="d-flex flex-column align-items-center">
    <div class="influencer-summarize-value">{{influencer.value | thousandNumberSuffix}}</div>
    <div class="d-flex flex-row influencer-summarize-status">
      <div *ngIf="influencer.status === 'asc'">
        <svg width="12px" height="12px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink">
          <desc></desc>
          <defs>
            <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
          </defs>
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Keyicons/Chevron-up">
              <g id="Chevron-down">
                <rect id="Transparent" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="20" height="20"></rect>
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1"></use>
                </mask>
                <use id="Mask" fill="#717D8D" fill-rule="nonzero"
                     transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) "
                     xlink:href="#path-1"></use>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div *ngIf="influencer.status === 'desc'" class="mr-1 desc-icon-wrapper">
        <svg width="12px" height="12px" viewBox="0 0 8 5" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
          </defs>
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Keyicons/Chevron-down" transform="translate(-6.000000, -8.000000)">
              <g id="Chevron-down">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1"></use>
                </mask>
                <use id="Mask" fill="#717D8D" fill-rule="nonzero" xlink:href="#path-1"></use>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <span [ngClass]="{'platform-reach-data-sublabel-asc': influencer.status === 'asc',
                            'platform-reach-data-sublabel-desc': influencer.status === 'desc'}">
            {{influencer.percent | percentNumberSuffix}}
    </span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/influencer-overview-report/influencer-summarize/influencer-summarize.component.html